import { FC } from 'react';
import { DisputeChevron } from './DisputeZoneChip';
import { DisputeTaggedText } from './DisputeTaggedText';

interface DisputeWaysToReduceProps {
  tips: string[];
  expanded: boolean;
  onToggle: () => void;
}

const DisputeWaysToReduce: FC<DisputeWaysToReduceProps> = ({ tips, expanded, onToggle }) => (
  <section>
    <button
      type="button"
      className="flex w-full items-center gap-3 text-left"
      onClick={onToggle}
      aria-expanded={expanded}>
      <span className="flex-1 text-sbase font-semibold text-accentText">Ways to reduce disputes</span>
      <span className={`inline-flex ${expanded ? 'rotate-90' : ''}`} aria-hidden="true">
        <DisputeChevron />
      </span>
    </button>
    {expanded ? (
      <ul className="mt-5 list-disc space-y-5 pl-5 text-sbase text-primaryText">
        {tips.map(tip => (
          <li key={tip}>
            <DisputeTaggedText text={tip} />
          </li>
        ))}
      </ul>
    ) : null}
  </section>
);

export default DisputeWaysToReduce;
